// extracted by mini-css-extract-plugin
var _1 = "body__GhFRc";
var _2 = "drawer__ww6mr";
var _3 = "footer__Dr4m5";
var _4 = "footerText__f4wM4";
var _5 = "header__coy8S";
var _6 = "link__Txlkp";
var _7 = "logo__lTLqt";
var _8 = "main__gzOZB";
var _9 = "mobileMenu__Abh8n";
var _a = "navWrapper__fOM0B";
var _b = "visible__duvar";
export { _1 as "body", _2 as "drawer", _3 as "footer", _4 as "footerText", _5 as "header", _6 as "link", _7 as "logo", _8 as "main", _9 as "mobileMenu", _a as "navWrapper", _b as "visible" }
export default { "body": _1, "drawer": _2, "footer": _3, "footerText": _4, "header": _5, "link": _6, "logo": _7, "main": _8, "mobileMenu": _9, "navWrapper": _a, "visible": _b }
